import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import moment from "moment";

import { getRecipeComments } from "../../../../store/actions";
import StarRating from "../../../../sharedComponents/starRating";
import PlaceholderIMG from "../../../../sharedComponents/placeholderImage";
import ProfileImage from "../../../../assets/images/profile-picture.png";

const RecipeComments = ({ recipeId, getRecipeComments, recipeComments }) => {
	useEffect(() => {
		recipeId && getRecipeComments(recipeId);
	}, [getRecipeComments, recipeId]);

	return recipeComments && recipeComments.length ? (
		<div className="block-section recipe-comments">
			<h4 className="title-black border-bottom-default pb-2">
				{`${recipeComments.length} comment${recipeComments.length > 1 ? "s" : ""} posted`}
			</h4>
			<ul className="comments-listing">
				{recipeComments &&
					recipeComments.map((item, index) => {
						const user = item.user;
						return (
							<li key={index} className="d-flex">
								<div className="mr-3 profile-image-container">
									<PlaceholderIMG
										width="40"
										height="40"
										text={user.first_name.substr(0, 1)}
										src={ProfileImage}
										bg="rgba(0,0,0,0.1)"
										color="rgba(0,0,0,0.3)"
									/>
								</div>
								<div>
									<div>
										<span className="text-primary-dark">
											{user.first_name} {user.middle_name}
										</span>{" "}
										- {user.city}, {user.state}
									</div>
									<div className="small">{moment(item.created).format("LL")}</div>
									<StarRating value={item.rating} />
									<h4 className="text-black mt-3">{item.title}</h4>
									<div>{item.notes}</div>
								</div>
							</li>
						);
					})}
			</ul>
		</div>
	) : null;
};

const mapStateToProps = (state) => {
	return {
		recipeComments: get(state, "Recipes.recipeCommentsResult.results", [])
	};
};

const mapDispatchToProps = { getRecipeComments };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RecipeComments);
